module.exports = __webpack_public_path__ + "static/media/Artboard13.4e33ce73.png";